/**
 * Theme Index
 * Exporta o tema MUI como default e re-exporta componentes premium
 */

import { useMemo } from 'react';
import { createTheme } from '@mui/material/styles';
import palette from './palette';
import dimensions from './dimensions';
import components from './components';
import premiumTokens from './premiumTokens';

// Import animations CSS (side-effect only)
import './animations.css';

// ============================================================================
// DEFAULT EXPORT: MUI Theme Creator
// ============================================================================
export default (server, revenda, darkMode, direction) => useMemo(() => {
  const basePalette = palette(server, revenda, darkMode);

  return createTheme({
    typography: {
      // Premium typography com Inter para headings
      fontFamily: premiumTokens.typography.fontFamily.body,
      h1: {
        fontFamily: premiumTokens.typography.fontFamily.heading,
        fontWeight: premiumTokens.typography.fontWeight.semibold,
      },
      h2: {
        fontFamily: premiumTokens.typography.fontFamily.heading,
        fontWeight: premiumTokens.typography.fontWeight.semibold,
      },
      h3: {
        fontFamily: premiumTokens.typography.fontFamily.heading,
        fontWeight: premiumTokens.typography.fontWeight.medium,
      },
      h4: {
        fontFamily: premiumTokens.typography.fontFamily.heading,
        fontWeight: premiumTokens.typography.fontWeight.medium,
      },
      h5: {
        fontFamily: premiumTokens.typography.fontFamily.heading,
        fontWeight: premiumTokens.typography.fontWeight.medium,
      },
      h6: {
        fontFamily: premiumTokens.typography.fontFamily.heading,
        fontWeight: premiumTokens.typography.fontWeight.medium,
      },
      body1: {
        fontSize: premiumTokens.typography.fontSize.md,
        lineHeight: premiumTokens.typography.lineHeight.normal,
      },
      body2: {
        fontSize: premiumTokens.typography.fontSize.sm,
        lineHeight: premiumTokens.typography.lineHeight.normal,
      },
      caption: {
        fontFamily: premiumTokens.typography.fontFamily.mono,
        fontSize: premiumTokens.typography.fontSize.xs,
      },
      overline: {
        fontFamily: premiumTokens.typography.fontFamily.mono,
        fontSize: premiumTokens.typography.fontSize.xs,
        letterSpacing: premiumTokens.typography.letterSpacing.wide,
      },
    },
    palette: basePalette,
    direction,
    dimensions,
    components,
    // Premium tokens acessíveis via theme.premium
    premium: premiumTokens,
  });
}, [server, revenda, darkMode, direction]);

// ============================================================================
// RE-EXPORT: Premium Tokens Hooks
// ============================================================================
export {
  usePremiumTokens,
  useGlassmorphism,
  useStatusTokens,
  useTripStatusTokens,
  useButtonTokens,
  useChartTokens,
  useCommandBarTokens,
  useActivityFeedTokens,
  useCrudTokens,
  useComponentTokens,
  useSemanticTokens,
  useTextTokens,
  useBorderTokens,
  useShadowTokens,
  usePremiumInputStyles,
  usePremiumTableStyles,
  usePremiumCardStyles,
} from './usePremiumTokens';
